import { fetchWithAuth } from "../../auth/auth";
import { getApiUrl } from "../../utils/getApiUrl";
import type { UserModel } from "../../type/user";
import { normalizeParameters } from "../../utils/usersParameters";

export async function fetchAllUsers(): Promise<UserModel[]> {
  const resp = await fetchWithAuth(getApiUrl("user/getall"), {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  if (!resp.ok) return [];
  const data = await resp.json();

  if (!Array.isArray(data)) return [];
  
  return data.map((u) => ({
    ...u,
    parameters: normalizeParameters(u.parameters),
  }));
}
